import ogImage from '../assets/aadarsh.webp';

export const defaultMeta = {
  title: "Aadarsh R | Freelance Digital Marketer In Thiruvalla",
  description: "Grow your brand with the Best Digital Marketing Expert in Thiruvalla, Kerala. I'm Aadarsh, also a proven SEO Expert  with 4+ years experience and a 100% project success rate. Maximize your brand's visibility, generate quality leads, and drive actual sales.",
  keywords: "Digital Marketing Expert In Thiruvalla, SEO Expert",
  author: "Aadarsh Rajesh Kumar",
  image: `https://aadarshrajesh.page${ogImage}`,
  url: "https://aadarshrajesh.page/",
  type: "website",
  favicon: "https://aadarshrajesh.page/favicon.svg"
};

export const pagesMeta = {
  home: {
    title: "Aadarsh R | Freelance Digital Marketer In Thiruvalla",
    description: "Grow your brand with the Best Digital Marketing Expert in Thiruvalla, Kerala. I'm Aadarsh, also a proven SEO Expert  with 4+ years experience and a 100% project success rate. Maximize your brand's visibility, generate quality leads, and drive actual sales.",
    keywords: "Digital Marketing Expert In Thiruvalla, SEO Expert",
  },
  blog: {
    title: "Blog - Latest Articles & Insights | Aadarsh R | Freelance Digital Marketer In Thiruvalla",
    description: "Explore articles on web development, digital marketing, SEO strategies, and software engineering best practices by Aadarsh Rajesh Kumar.",
    keywords: "blog, web development articles, digital marketing tips, SEO guides, software engineering, tech blog",
    url: "https://aadarshrajesh.page/blog"
  }
};
